<template>
  <div class="billManagement">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 15px 0 0 10px;"  >
      <el-breadcrumb-item :to="{ path: '/inventoryOrder' }" class="textColer">返回</el-breadcrumb-item>
      <el-breadcrumb-item>人员</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="height: 75vh">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%; margin-top: 15px" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="personName" label="人员" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeStart" label="盘库开始" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeEnd" label="盘库结束" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="safetyHatId" label="安全帽ID" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template #default="scope">
            <el-button type="text" v-if="scope.row.safetyHatId" @click="shipin(scope.row)">视频</el-button>
            <el-button type="text" v-if="scope.row.safetyHatId&&scope.row.inventoryTimeStart&&!scope.row.inventoryTimeEnd" :disabled="jkDis" @click="jiankong(scope.row)">监控</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="视频" v-if="dialogVisible" :visible.sync="dialogVisible" width="80%" center>
      <div style="width: 100%; display: flex;height: 500px">
        <div style="width: 60%; ">
          <div v-if="url.substr(-3,3)=='mp4'">
            <video style="width: 100%; height: 100%" v-for="(item, index) in videoList" :key="item.id" v-show="index == current" muted="" :loop="false" poster="" controls="" :autoplay="false">
              <source :src="item.url" type="video/mp4" />
            </video>
          </div>
          <div v-else-if="url.substr(-3,3) == 'flv'" style="height:411px;">
            <VideoPlayer :url="url" ref='video' />
          </div>
        </div>
        <div style="width: 30%; padding-left: 20px;">
          <div style="height: 25px; line-height: 25px">视频列表</div>
          <div style="height: 25px; line-height: 25px">{{personName}}</div>
          <div style="height:430px; overflow: auto; margin-top: 10px">
            <div :class="{ active: current == index }" style="cursor: pointer; padding: 0 5px; margin-bottom: 5px" v-for="(item, index) in videoList" :key="item.time" @click="showVideo(item, index)">
              {{ item.time }}
            </div>
          </div>
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="
            () => {
              dialogVisible = false;
              url = '';
            }
          ">关 闭</el-button>
      </span> -->
    </el-dialog>
    <el-dialog title="监控" v-if="dialogJKVisible" :visible.sync="dialogJKVisible" width="80%" center :before-close="closeJk">
      <div style="width: 100%">
        <VideoPlayer :url="videoUrl" ref='video' />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VideoPlayer from './TcPlayer.vue'
import {
  getInventoryPersonList,
  getVideoUrl,
  jiankongLogin,
  jiankongToken
} from '@/api/wms-stock'
export default {
  components: { VideoPlayer },
  data () {
    return {
      tableData: [],
      dialogVisible: false,
      url: '',
      videoList: [],
      current: 0,
      personName: '',
      webSocket: null,
      wsUrl: 'wss://caps.runde.pro/wss',
      adminName: 'CS870W',
      device_id: '',
      Intervel: null,
      playVideo: {},
      videoUrl: '',
      dialogJKVisible: false,
      jkDis: false,
      isLogin: false
    }
  },
  created () {
    this.getInventoryPersonList()
  },
  mounted () {
    this.initWebSocket()
  },
  beforeDestroy () {
    window.clearInterval(this.Intervel)
    this.Intervel = null
    this.socketClosed = false
    // 离开路由之后断开websocket连接
    this.webSocket.close()
  },
  methods: {
    closeJk () {
      window.clearInterval(this.Intervel)
      this.Intervel = null
      this.dialogJKVisible = false

      this.$refs.video.pause()
      setTimeout(() => {
        this.websocketsend(
          JSON.stringify({ act: 'ma_stop_rtsp', device_id: this.device_id })
        )
      }, 2000)
    },
    async jiankong (row) {
      this.jkDis = true
      this.device_id = row.safetyHatId
      if (this.socketClosed) {
        this.initWebSocket()
      }

      const token = await jiankongToken()
      this.websocketsend(
        JSON.stringify({
          act: 'ma_login',
          user_name: this.adminName,
          access_token: token
        })
      )
    },
    initWebSocket () {
      this.webSocket = new WebSocket(this.wsUrl)
      this.webSocket.onmessage = this.websocketOnMessage
      this.webSocket.onopen = this.websocketOnOpen
      this.webSocket.onerror = this.websocketOnError
      this.webSocket.onclose = this.websocketOnClose
    },
    websocketOnMessage (e) {
      console.log(e.data)
      const jsons = JSON.parse(e.data)
      switch (jsons.cmd) {
        case 'ma_login':
          if (jsons.msg_code == 'TooManyLogin') {
            this.jkDis = false
          }
          this.isLogin = true
          this.websocketsend(JSON.stringify({ act: 'ma_get_active_devices' }))
          this.Intervel = window.setInterval(() => {
            this.websocketsend(
              JSON.stringify({ act: 'ma_get_active_devices' })
            )
          }, 25000)
          break
        case 'ma_get_active_devices':
          // console.log(jsons.msg_code)
          let isActive
          if (jsons.data) { isActive = jsons.data.some(item => item.user_info.device_id == this.device_id) }
          console.log(isActive, jsons, this.device_id)
          if (jsons.msg_code == 'HaveNoDeviceOnLine' || !isActive) {
            this.$message({ message: '设备未登录', type: 'error' })
            this.jkDis = false
            window.clearInterval(this.Intervel)
            this.Intervel = null
          } else {
            if (this.jkDis) {
              this.websocketsend(
                JSON.stringify({ act: 'ma_open_rtsp', device_id: this.device_id })
              )
            }
          }
          break
        case 'ma_open_rtsp':
          if (jsons.status) {
            const url = jsons.play_url[2].replace('\\', '')
            this.videoUrl = url
            this.dialogJKVisible = true
          } else {
            this.jkDis = false
            this.$message({ message: jsons.msg, type: 'error' })
          }

          break
        case 'ma_stop_rtsp':
          console.log('停止推流')
          this.jkDis = false

          window.clearInterval(this.Intervel)
          this.Intervel = null
          break
      }
    },
    websocketOnOpen () {
      console.log('websocket已开启')
    },
    websocketOnError () {
      this.initWebSocket()
    },
    websocketsend (Data) {
      // 数据发送
      this.webSocket.send(Data)
    },
    websocketOnClose () {
      this.socketClosed = true
      console.log('websocket已关闭')
    },
    showVideo (item, index) {
      this.url = item.url
      this.current = index
    },
    getInventoryPersonList () {
      getInventoryPersonList({
        inventoryMasterId: this.$route.query.inventoryMasterId
      })
        .then((res) => {
          console.log(res)
          this.tableData = res
        })
        .catch((error) => {
          this.$message.error(error.message)
        })
    },
    shipin (item) {
      this.personName = item.personName
      getVideoUrl({
        inventoryPersonId: item.inventoryPersonId
      })
        .then((res) => {
          if (res == null) {
            this.$message.error('视频上传中，请耐心等待。')
          } else {
            console.log(res)
            if (res == '无视频') {
              this.$message({ message: '视频上传中，请耐心等待。', type: 'error' })
              return
            }
            this.videoList = res
            this.url = res[0].url
            this.current = 0
            this.dialogVisible = true
          }
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.active {
  background: rgba(14, 110, 236, 0.3);
}

</style>
